import {Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {MatIcon} from "@angular/material/icon";

@Component({
  selector: 'app-image-list-element',
  templateUrl: './image-list-element.component.html',
  standalone: true,
  imports: [
    MatIcon
  ],
  styleUrls: ['./image-list-element.component.css']
})
export class ImageListElementComponent {
  @Input() file: File;
  @Output() fileDeleted = new EventEmitter<File>();

  deleteFile() {
    this.file = null;
    this.fileDeleted.emit(this.file);
  }
}
